import { Badge } from "@mantine/core";

interface IsDoneBadgeProps {
  isDone: boolean;
}

function IsDoneBadge({ isDone }: IsDoneBadgeProps) {
  if (!isDone) {
    return null;
  }
  return (
    <Badge
      className="onboarding-assignment-done-badge"
      color="success"
      data-testid="onboarding-assignment-done-badge"
      variant="light"
    >
      Erledigt
    </Badge>
  );
}

export { IsDoneBadge };
